import { defaultSearchFormState } from 'config/SearchForm/defaults';
import { atom } from 'jotai';
import { focusAtom } from 'jotai-optics';

// base Atom for the whole search (based on the default Search)
export const baseSearchFormAtom = atom(defaultSearchFormState);

// atom for the current search
export const currentSearchAtom = focusAtom(baseSearchFormAtom, (optic) =>
    optic.prop('current')
);

export const recentSearchAtom = focusAtom(baseSearchFormAtom, (optic) =>
    optic.prop('recent')
);

export const destinationAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('destination')
);

export const cityIdListAtom = focusAtom(destinationAtom, (optic) =>
    optic.prop('cityIdList')
);

export const regionIdListAtom = focusAtom(destinationAtom, (optic) =>
    optic.prop('regionIdList')
);

export const destinationLabelAtom = focusAtom(destinationAtom, (optic) =>
    optic.prop('label')
);
export const geoFenceAtom = focusAtom(destinationAtom, (optic) =>
    optic.prop('geoFence')
);

export const departureAirportAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('departureAirportList')
);

export const occupancyAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('occupancy')
);

export const travelPeriodAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('travelPeriod')
);

export const travelDurationAtom = focusAtom(travelPeriodAtom, (optic) =>
    optic.prop('duration')
);

export const departureDateAtom = focusAtom(travelPeriodAtom, (optic) =>
    optic.prop('departureDate')
);

export const returnDateAtom = focusAtom(travelPeriodAtom, (optic) =>
    optic.prop('returnDate')
);

export const sortingAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('sorting')
);

export const regionSortOrderAtom = focusAtom(sortingAtom, (optic) =>
    optic.prop('region')
);
export const hotelSortOrderAtom = focusAtom(sortingAtom, (optic) =>
    optic.prop('hotel')
);
export const offerSortOrderAtom = focusAtom(sortingAtom, (optic) =>
    optic.prop('offer')
);

export const paginationAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('pagination')
);
